export const toMap = (data) => {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.reduce((acc, item) => {
    acc.set(item.id, item);
    return acc;
  }, new Map());
};
